export enum EIdentVerificationState {
    SERVICE_NOT_AVAILABLE = 'service-not-available',
    INITIALISING = 'initializing',
    READY = 'ready',
    VERIFICATION_IN_PROGRESS = 'in-progress',
    VERIFICATION_FAILURE = 'failure'
}
